import styled, { css } from 'styled-components';

interface IImageContainerProps {
  isDynamic?: boolean;
}

export const ImageContainer = styled.span<IImageContainerProps>`
  position: relative;
  display: inline-block;
  width: 195px;
  height: 128px;
  border-radius: 4px;
  overflow: hidden;

  .imageOverlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    opacity: 0;
    transition: opacity 0.2s ease;
    background-color: #000000;
    border-radius: 4px;
    overflow: hidden;
    z-index: 3;
  }

  img {
    width: 195px;
    height: 128px;
    object-fit: cover;
    display: block;
    border-radius: 4px;
    overflow: hidden;
  }

  &:hover {
    .btnOverlay {
      opacity: 1;
    }
  
    .imageOverlay {
      opacity: 0.5;
      transition: opacity 0.2s ease;
    }
  }

  ${({ isDynamic }) =>
    isDynamic &&
    css`
      width: 110px;
      height: 72px;

      img {
        width: 110px;
        height: 72px;
      }
    `}
`;

export const ProgressOverlay = styled.div`
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  padding: 0 6px;
  z-index: 4;
`;

export const ButtonOverlay = styled.button`
  position: absolute;
  top: 6px;
  right: 6px;
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.2s ease;
  border-radius: 5px;
  border: none;
  background-color: ${({ theme }) => theme.colors.secondary.secondary};
  color: ${({ theme }) => theme.colors.secondary.onSecondary};
  z-index: 4;
  cursor: pointer;

  .iconBtnOverlay {
    color: ${({ theme }) => theme.colors.secondary.onSecondary} !important;
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.secondary.onSecondaryHover}, ${theme.colors.secondary.secondary})`} !important;
  }
  &:active {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.secondary.onSecondaryPressed}, ${theme.colors.secondary.secondary})`} !important;
  }
  &:focus {
    border: 2px solid ${({ theme }) => `color-mix(in srgb, ${theme.colors.secondary.onSecondaryOutline}, ${theme.colors.secondary.secondary})`} !important;
  }

  i {
    color: white;
  }
`;

export const ButtonMoreActions = styled.button`
  padding: 5px;
  background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
  border-radius: 5px;
  margin-left: 6px;
  border: none;
  cursor: pointer;

  &:hover {
    background-color: ${({ theme }) => theme.colors.surface.onSurfacePlaceholder};
  }
`;

export const Container = styled.div`
  width: 200px;
  display: flex;
  flex-direction: column;
  border-radius: 6px;
  background-color: ${({ theme }) => theme.colors.surface.surface};

  .dividerContainer {
    width: 100%;
    height: 1px;
    padding: 0 6px;

    .divider {
      width: 100%;
      height: 1px;
      background-color: ${({ theme }) => theme.colors.surface.surfaceOutline};
    }
  }
`;

export const Card = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 6px;
  gap: 2px;
`;

interface ICardItemProps {
  isdelete?: boolean;
}

export const CardItem = styled.div<ICardItemProps>`
  width: 100%;
  height: 32px;
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 6px;
  border-radius: 4px;
  background-color: ${({ theme }) => theme.colors.surface.surface};
  cursor: pointer;

  .cardItemIcon {
    color: ${({ theme }) => theme.colors.surface.onSurfaceVariant} !important;
  }

  .cardItemText {
    font-size: 12px;
    font-weight: 400;
    line-height: 20px;
    color: ${({ theme }) => theme.colors.surface.onSurface};
    margin-left: 6px;
  }

  &:hover {
    background-color: ${({ theme }) => `color-mix(in srgb, ${theme.colors.surface.onSurfaceHover}, ${theme.colors.surface.surface})`};
  }

  ${({ isdelete, theme }) => isdelete && css`
    
    &:hover {
      background-color: ${`color-mix(in srgb, ${theme.colors.danger.dangerHover}, ${theme.colors.surface.surface})`};
      
      .cardItemIcon {
        color: ${theme.colors.danger.danger} !important;
      }
    }
  `}
`;
